module.exports = __webpack_public_path__ + "img/item1.17c6eb4c.svg";